import { baseCRUDAPI } from './base';

const getCachedParams = (cached) => (cached ? '' : `?unique=${Math.round(+new Date() / 1000)}`);

export default class DashboardResource extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'DashboardResource');
  }

  async GetActive(cached) {
    const { data } = await this.axiosObject.get(`${this.apiBaseName}/GetActive${getCachedParams(cached)}`);
    return data;
  }

  async Download(id) {
    const response = await this.axiosObject.post(`${this.apiBaseName}/Download/${id}`, null, {
      responseType: 'blob', // Important for handling binary data
      headers: {
        'Content-Type': 'application/json', // Since it's a POST request, we specify the content type
      },
    });

    return response;
  }
}
